import React, {Key, useEffect, useState} from 'react';
import {DetailGrid, Utility} from '@/components/GridWidget';
import {WdiCardTitle, wdiCore, WdiModalAppResult, WdiModalProps} from '@/components/WdiControls';
import {Button, Input, message, Space} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats,} from '@/components/WdiBus/TableColumnRanderFormats';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import DataStore from '@/components/GridWidget/DataStore';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {ResponseStatus} from '@/utils/request';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {getSchemaColumns, toExcel, ToExcelProps} from '@/components/WdiControls/WdiExcel';
import {getAllHasValueColumns} from '@/pages/sales/sa/components/data';
import {FieldConfigUtility, getEcDefFields} from '@/components/WdiBus/EcFieldConfig';
import {WdiSelect, WdiSelectFormat} from '@/components/WdiControls/WdiSelect';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {FormSp} from '@/services/sales/sp';
import {ShipTo} from '@/services/mdm/shipto';
import {EC} from "@/services/mdm/ec";
import GeneralSpDetailEditApp from "@/pages/sales/sp/components/DetailEdit";
import {Position} from "@/services/basic/position";
import ModifyPaymentAmountModalApp from "@/pages/sales/sp/components/ModifyPaymentAmount";
import PageControl, {getFormUrlMapping} from '@/components/WdiBus/FormPage';
import SpSaDetailSelectApp from "@/pages/sales/sp/components/SpSaDetailSelect";
import ViewSfaResultApp from "@/pages/sales/sp/components/ViewSfaResult";

const ModalAppTypeEnums = {
  None: 0,
  Insert: 1,
  Edit: 2,
  Import: 3,
  Select: 4,
  ViewSfa: 5,
};

export type DetailForApplyProps = {
  data?: any,
  dataSource: any[],
  onChange?: (dataSource: any) => void;
  onClose?: (result?: WdiModalAppResult) => void;
}

/**
 * 默认列：行号，四级使用部门，客户，收货地，门店，产品别，费用项，可核销金额，实际POS销量(用户填写)，实际POS销售额(用户填写)，核销金额(含税)，核销金额(不含税)，核销备注
 * 扩展列：活动明细编号，申请金额，系统计算金额，已核销金额，税金，
 */
export const initApplyRowFieldConfigs = (record: any, ecFieldConfigs: API.EcFieldConfig[] | undefined) => {
  const columns = [
    'boId', 'soldToCode', 'shipToCode', 'shopId', 'productBuyIds', 'ecId', 'amountNotPaid', 'quantityPosActualKeyin',
    'revenuePosActualKeyin', 'amountInVat', 'amountExVat', 'remark', 'tpmDetailId', 'amountSa', 'amountActual',
    'amountPaid', 'tax', 'revenueType', 'paymentMethodId', 'boId1', 'boId2', 'boId3', 'ecId1', 'ecId2', 'toSfa',
    'roiForecast', 'remarkSa', "companyCode",
  ];
  columns.push(...getAllHasValueColumns(record));
  if (ecFieldConfigs && ecFieldConfigs.length > 0) {
    if (record.extendFieldsSa || record.revExtendFieldsSa) {
      columns.push(
        ...getEcDefFields(
          ecFieldConfigs,
          FieldConfigUtility.merge(record.extendFieldsSa, record.revExtendFieldsSa),
        ),
      );
    }
  }
  return columns;
};

const vatTypeValidate = (vatType?: any) => {
  if (!vatType || wdiCore.Object.IsNullOrUndefined(vatType.vatTypeId)) {
    message.error("请先选择税率").then();
    return false
  }
  return true;
};

export const GeneralPaymentDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false, type: ModalAppTypeEnums.None,});
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const [ecFieldConfigs, setEcFieldConfigs] = useState<API.EcFieldConfig[]>([]);

  const {data, dataSource, onChange} = props;
  const {formSp, vatType} = data;

  const initImportExcel = () => {
    // 收货地编号，收货地名称，客户编号，客户名称，四级使用部门（取shipto的boid）
    const shipToColumns = [
      {name: 'shipToCode', displayName: '收货地编号'},
      {name: 'shipToName', displayName: '收货地名称'},
      {name: 'soldToCode', displayName: '客户编号'},
      {name: 'soldToName', displayName: '客户名称'},
      {name: 'boName', displayName: '四级使用部门'},
    ];
    const shipToSheet = {
      dataLoading: async (params: any) => {
        return await ShipTo.searchExcel({withPermissions: true});
      },
      data: null,
      names: shipToColumns,
      sheetName: '收货地',
    };
    const importExcels: ToExcelProps[] = [];
    importExcels.push({
      name: '全部下载',
      sheetProps: [shipToSheet],
    });
    importExcels.push({
      name: '收货地列表',
      sheetProps: [shipToSheet],
    });
    setImportExcels(importExcels);
  };

  const onClose = () => {
    setModalProps({visible: false, title: "", type: ModalAppTypeEnums.None, id: null, data: null});
  };
  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      const data = uploadResult?.data?.data;
      if (data && data.length > 0) {
        if (uploadResult?.data?.exProperty) {
          //是否清空
          onChange?.(DataStore.init(data));
        } else {
          const newDataSource = [...dataSource];
          const importDataMap = new Map<number, any>(data.map((item: any) => [item.formSaDetailId, item]));
          newDataSource.forEach((record) => {
            const item = importDataMap.get(record.formSaDetailId);
            if (item) {
              record.shipToCode = item.shipToCode;
              record.quantityPosActualKeyin = wdiCore.Number.ToNumber(item.quantityPosActualKeyin, 2);
              record.revenuePosActualKeyin = wdiCore.Number.ToNumber(item.revenuePosActualKeyin, 2);
              record.amountExVat = wdiCore.Number.ToNumber(item.amountExVat, 2);
              record.amountInVat = wdiCore.Number.ToNumber(item.amountInVat, 2);
              record.tax = wdiCore.Number.ToNumber(item.tax, 2);
              record.remark = item.remark;
              // 从Map中删除已处理的项
              importDataMap.delete(record.formSaDetailId);
            }
          });
          newDataSource.push(...importDataMap.values());
          onChange?.(DataStore.init(newDataSource));
        }
      }
    }
    onClose();
  };
  const onModalSave = async (result: any) => {
    if (result.code == ResponseStatus.SUCCESS) {
      const soldToCodes = new Set<string>(result?.data.map((item: any) => (item.soldToCode)));
      const shipMap: Map<string, API.ShipTo | undefined> = new Map();
      for (const soldToCode of soldToCodes) {
        const shipToRes = await ShipTo.ajaxSearch({top: 2, isActive: true, soldToCode: soldToCode});
        shipMap.set(soldToCode, shipToRes.data.length == 1 ? shipToRes.data[0] : undefined);
      }
      const newDataSource = [...dataSource];
      result?.data.map((row: any) => {
        const index = newDataSource.findIndex((item: any) => item.formSaDetailId == row.formSaDetailId);
        if (index < 0) {
          row.shipToCode = shipMap.get(row.soldToCode)?.shipToCode;
          row.shipToName = shipMap.get(row.soldToCode)?.shipToName;
          newDataSource.push(row);
        }
      });
      onChange?.(DataStore.init(newDataSource));
    }
    setModalProps({visible: false, title: '', id: null});
  };

  useEffect(() => {
    (async () => {
      const response = await EC.getEcFieldConfigs();
      setEcFieldConfigs(response.data)
    })()
  }, []);

  const getEcFieldConfig = (key: string, record: any) => {
    const extendFieldsSa = FieldConfigUtility.merge(record.extendFieldsSa, record.revExtendFieldsSa);
    const cfg = ecFieldConfigs.find((item) => item.fieldKey == key);
    if (cfg && cfg.bitValue) {
      return FieldConfigUtility.get(cfg.bitValue, extendFieldsSa);
    }
    return {contain: false, req: false};
  }

  useEffect(() => {
    if (formSp.paymentMethodId) {
      GridApi.searchConfig({id: 'FormSPDetailForGeneral', allowModifyColumns: true}).then((response) => {
        const settings: any = Object.assign({}, response.data, {
          actionsAlign: NsGrid.ActionsAlign.Left,
          showAggr: true,
          showExpandedRow: true,
        });

        initFieldDisplayFormater(settings.formSchema.allFields);

        settings.formSchema.allFields.tpmDetailId.getDisplayFormater = (text: any, record: any, index: any) => {
          return (
            <a onClick={() => {
              window.open(getFormUrlMapping(record.saPageTypeId, record.saFormTypeId) + `?formId=${record.formSaId}&pageTypeId=${record.saPageTypeId}&formTypeId=${record.saFormTypeId}`);
            }}>{record.tpmDetailId}
            </a>
          )
        };

        settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr('amountNotPaid', 2);
        settings.formSchema.allFields.quantityPosActualKeyin.aggr = TableColumnRanderFormats.sumAggr('quantityPosActualKeyin', 2);
        settings.formSchema.allFields.revenuePosActualKeyin.aggr = TableColumnRanderFormats.sumAggr('revenuePosActualKeyin', 2);
        settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr('amountExVat', 2);
        settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2);
        settings.formSchema.allFields.amountSa.aggr = TableColumnRanderFormats.sumAggr('amountSa', 2);
        settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);
        settings.formSchema.allFields.amountPaid.aggr = TableColumnRanderFormats.sumAggr('amountPaid', 2);
        settings.formSchema.allFields.tax.aggr = TableColumnRanderFormats.sumAggr('tax', 2);
        if (formSp.paymentMethodId != Enum.PaymentMethod.BILL_DEDUCT && settings && settings.viewObject) {
          settings.viewObject.viewColumns = settings.viewObject.viewColumns.filter(
            (item: any) => item != 'shipToCode',
          );
        }
        settings.formSchema.allFields.rowNumber.width = 70;
        settings.formSchema.allFields.soldToCode.width = 100;
        settings.formSchema.allFields.shipToCode.width = 100;
        settings.formSchema.allFields.productBuyIds.width = 100;
        settings.formSchema.allFields.ecId.width = 90;
        settings.formSchema.allFields.boId.width = 120;
        settings.formSchema.allFields.amountNotPaid.width = 110;
        settings.formSchema.allFields.quantityPosActualKeyin.width = 185;
        settings.formSchema.allFields.revenuePosActualKeyin.width = 200;
        settings.formSchema.allFields.amountInVat.width = 150;
        settings.formSchema.allFields.amountExVat.width = 150;
        settings.formSchema.allFields.remark.width = 150;

        const actions: any[] = [];
        if (settings.formSchema.actions) {
          settings.formSchema.actions.forEach((item: any) => {
            if (wdiCore.String.EqIngoreCase(item.name, 'SystemDelete') && formSp.pageGroupId == Enum.PageGroup.ACTIVITY_BATCH_PAYMENT) {
              Utility.setActionCallback(settings.formSchema.actions, 'SystemDelete',
                async (grid: any, action: any, record: any) => {
                  if (window.confirm("确定要删除吗？")) {
                    const context = grid.getContext();
                    onChange?.(DataStore.del(context.dataSource, record.uid));
                    message.success("删除成功");
                  }
                },
              );
              actions.push(item);
            }
          });
        }
        settings.formSchema.actions = actions;

        initImportExcel();
        setGridSettings(settings);
        setIsLoaded(true);
      });
    }
  }, [formSp.paymentMethodId]);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initApplyRowFieldConfigs(record, data?.ecFieldConfigs);
    },
    pagination: {
      pageSize: 10,
      showSizeChanger: true
    },
  };


  const editColumn = {
    shipToCode: (_t: any, record: any, index: any) => {
      return record.paymentMethodId == Enum.PaymentMethod.BILL_DEDUCT ? (
        <WdiSelect {...{
          style: {width: '100%'},
          allowClear: true,
          placeholder: "请选择收货地",
          labelInValue: true,
          remote: true,
          value: record.shipToCode ? {
            value: record.shipToCode,
            label: wdiCore.String.CodeOrName(record.shipToCode, record.shipToName)
          } : null,
          onChange: (value) => {
            if (value) {
              const shipToCode = WdiSelectFormat.getvalue(value);
              ShipTo.get(shipToCode).then(responseResult => {
                const {...newRecord} = record;
                newRecord.shipToCode = responseResult.data.shipToCode;
                newRecord.shipToName = responseResult.data.shipToName;
                onChange?.(DataStore.edit(dataSource, newRecord));
              })
            }
          },
          dataLoading: async (params) => {
            const response = await ShipTo.ajaxSearch(Object.assign({
              soldToCode: record.soldToCode,
              isActive: true
            }, params));
            return response.data.map((item) => {
              return {value: item.shipToCode, label: item.codeOrName};
            });
          }
        }} />
      ) : <></>
    },
    quantityPosActualKeyin: (_t: any, record: any, index: any) => {
      const fieldCfg = getEcFieldConfig("quantityPosForecast", record);
      return fieldCfg.contain || fieldCfg.req ? (
        <WdiInputNumber value={record.quantityPosActualKeyin} onBlur={(e: any) => {
          const {...newRecord} = record;
          newRecord.quantityPosActualKeyin = wdiCore.Number.ToNumber(e.target.value, 2);
          onChange?.(DataStore.edit(dataSource, newRecord));
        }}/>
      ) : <></>
    },
    revenuePosActualKeyin: (_t: any, record: any, index: any) => {
      const fieldCfg = getEcFieldConfig("revenuePosForecast", record);
      return fieldCfg.contain || fieldCfg.req ? (
        <WdiInputNumber value={record.revenuePosActualKeyin} onBlur={(e: any) => {
          const {...newRecord} = record;
          newRecord.revenuePosActualKeyin = wdiCore.Number.ToNumber(e.target.value, 2);
          onChange?.(DataStore.edit(dataSource, newRecord));
        }}/>
      ) : <></>
    },
    amountInVat: (_t: any, record: any, index: any) => {
      return <WdiInputNumber value={record.amountInVat} onBlur={(e: any) => {
        const {...newRecord} = record;
        newRecord.amountInVat = wdiCore.Number.ToNumber(e.target.value, 2);
        if (!wdiCore.Object.IsNullOrUndefined(vatType?.vatTypeValue)) {
          newRecord.amountExVat = wdiCore.Number.ToNumber(newRecord.amountInVat / (1 + vatType?.vatTypeValue), 2);
          newRecord.tax = wdiCore.Number.ToNumber(newRecord.amountInVat - newRecord.amountExVat, 2);
        }
        onChange?.(DataStore.edit(dataSource, newRecord));
      }}/>
    },
    amountExVat: (value: any, record: any, index: any) => {
      // 账扣/转账/第三方/记账时可编辑
      return (record.paymentMethodId == Enum.PaymentMethod.ACCOUNT_DEDUCT
        || record.paymentMethodId == Enum.PaymentMethod.TRANSFER
        || record.paymentMethodId == Enum.PaymentMethod.THIRD_PART
        || record.paymentMethodId == Enum.PaymentMethod.ACCOUNTING_ACCRUAL
        || record.paymentMethodId == Enum.PaymentMethod.ACCOUNTING_NO_ACCRUAL) ? (
        <WdiInputNumber value={record.amountExVat} onBlur={(e: any) => {
          const {...newRecord} = record;
          newRecord.amountExVat = wdiCore.Number.ToNumber(e.target.value, 2);
          newRecord.tax = wdiCore.Number.ToNumber(newRecord.amountInVat - newRecord.amountExVat, 2);
          onChange?.(DataStore.edit(dataSource, newRecord));
        }}/>
      ) : <>{wdiCore.Number.AmountToString(value)}</>
    },
    remark: (_t: any, record: any, index: any) => {
      return <Input value={record.remark} onChange={(e: any) => {
        const {...newRecord} = record;
        newRecord.remark = e.target.value;
        onChange?.(DataStore.edit(dataSource, newRecord));
      }}/>;
    }
  };

  return (
    <>
      {modalProps.visible && modalProps.type == ModalAppTypeEnums.ViewSfa && (
        <ViewSfaResultApp
          {...modalProps}
          onSave={onClose}
          onClose={onClose}
        />
      )}
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title="费用明细信息"/>}
        extra={
          <Space>
            {data.allowViewSfa && (
              <Button type='primary' onClick={(e) => {
                setModalProps({
                  title: '活动单查看SFA执行结果',
                  visible: true,
                  type: ModalAppTypeEnums.ViewSfa,
                  id: null,
                  data: {
                    dataSource: dataSource,
                    formTypeId: Enum.FormType.ACTIVITY_PAYMENT,
                  },
                });
              }}>
                查看SFA采集详情
              </Button>
            )}
            <Button type="primary" onClick={() => {
              if (vatTypeValidate(vatType)) {
                const newDataSource: any[] = [];
                dataSource?.forEach(item => {
                  item.amountInVat = wdiCore.Number.ToNumber(item.amountNotPaid, 2);
                  item.amountExVat = wdiCore.Number.ToNumber(item.amountInVat / (1 + vatType?.vatTypeValue), 2);
                  item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2);
                  newDataSource.push(Object.assign({}, item));
                });
                onChange?.(newDataSource);
              }
            }}>
              全部含税核销
            </Button>
            <Button type="primary" onClick={() => {
              if (vatTypeValidate(vatType)) {
                const newDataSource: any[] = [];
                dataSource?.forEach(item => {
                  item.amountExVat = wdiCore.Number.ToNumber(item.amountNotPaid, 2);
                  item.amountInVat = wdiCore.Number.ToNumber(item.amountExVat * (1 + vatType?.vatTypeValue), 2);
                  item.tax = wdiCore.Number.ToNumber(item.amountInVat - item.amountExVat, 2);
                  newDataSource.push(Object.assign({}, item));
                });
                onChange?.(newDataSource);
              }
            }}>
              全部未税核销
            </Button>
            {formSp.pageGroupId == Enum.PageGroup.ACTIVITY_BATCH_PAYMENT && (
              <Button
                type="primary"
                onClick={() => {
                  setModalProps({
                    title: '选择待核销的活动明细',
                    visible: true,
                    type: ModalAppTypeEnums.Select,
                    data: {
                      formSp: formSp,
                      dataSource: dataSource,
                    }
                  });
                }}
              >
                选择核销明细
              </Button>
            )}
            <Button type="primary" onClick={() => {
              if (vatTypeValidate(vatType)) {
                setModalProps({
                  title: '核销明细导入',
                  visible: true,
                  type: ModalAppTypeEnums.Import,
                });
              }
            }}>
              核销信息导入
            </Button>
          </Space>
        }
      >
        {isLoaded && modalProps.visible && modalProps.type == ModalAppTypeEnums.Select &&
          <SpSaDetailSelectApp
            {...modalProps}
            onClose={onClose}
            onSave={onModalSave}
          />
        }
        {isLoaded && modalProps.visible && modalProps.type == ModalAppTypeEnums.Import && (
          <ImportModalApp
            title={modalProps.title}
            visible={modalProps.visible}
            settingsUrl="/expenseapi/spButtons/getImportSettings"
            uploadingUrl="/expenseapi/spButtons/importUploading"
            onClose={onClose}
            onSave={onImportSave}
            clientParameters={{
              formSp: formSp,
              pageTypeId: formSp.pageTypeId,
              details: JSON.stringify(dataSource),
            }}
            importExcels={importExcels}
            events={{
              downloadFormSpDetailForApply: () => {
                const columns = [
                  {name: 'tpmDetailId', displayName: '活动明细编号*'},
                  {name: 'rowNumber', displayName: '行号'},
                  {name: 'boName', displayName: '四级使用部门'},
                  {name: 'soldToCode', displayName: '客户'},
                  {name: 'shipToCode', displayName: '收货地编号(用户填写，票扣时需填写)'},
                  {name: 'shopId', displayName: '门店'},
                  {name: 'productBuyNames', displayName: '产品别'},
                  {name: 'ecName', displayName: '费用项'},
                  {name: 'revenueTypeName', displayName: '核算类型'},
                  {name: 'paymentMethodName', displayName: '支付方式'},
                  {name: 'amountSa', displayName: '申请金额'},
                  {name: 'amountActual', displayName: '系统计算金额'},
                  {name: 'amountPaid', displayName: '已核销金额'},
                  {name: 'amountNotPaid', displayName: '可核销金额'},
                  {name: 'quantityPosForecast', displayName: '预计POS销量(箱/大袋)'},
                  {name: 'revenuePosForecast', displayName: '预计POS销售额'},
                  {name: 'quantityPosActualKeyin', displayName: '实际POS销量(箱/大袋)(用户填写)'},
                  {name: 'revenuePosActualKeyin', displayName: '实际POS销售额(用户填写)'},
                  {name: 'amountInVat', displayName: '核销金额(含税)*(用户填写)'},
                  {
                    name: 'amountExVat',
                    displayName: '核销金额(不含税)(账扣/转账/第三方/记账时可填，不填则自动计算)',
                  },
                  {name: 'remark', displayName: '核销备注(用户填写)'},
                ];
                const sheet = {
                  data: dataSource,
                  names: columns,
                  sheetName: 'FormSPApply',
                  cells: {
                    soldToCode: (_: any, row: any) => {
                      return wdiCore.String.CodeOrName(row.soldToCode, row.soldToName);
                    },
                    shopId: (_: any, row: any) => {
                      return wdiCore.String.CodeOrName(row.shopCode, row.shopName);
                    },
                  },
                };
                toExcel({
                  name: '核销信息_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
                  sheetProps: [sheet],
                });
              },
            }}
          />
        )}
        {isLoaded && (
          <DetailGrid {...pageGridSettings} params={data} editColumn={editColumn} autoColumn={['rowNumber']}/>
        )}
      </WdiPanel>
    </>
  );
}

export const FreeGoodsPaymentDetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const {data, dataSource} = props;

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSPDetailForFreeGoods', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr('amountNotPaid', 2);
      settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr('amountExVat', 2);
      settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2);
      settings.formSchema.allFields.amountSa.aggr = TableColumnRanderFormats.sumAggr('amountSa', 2);
      settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);
      settings.formSchema.allFields.amountPaid.aggr = TableColumnRanderFormats.sumAggr('amountPaid', 2);
      settings.formSchema.allFields.tax.aggr = TableColumnRanderFormats.sumAggr('tax', 2);

      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.soldToCode.width = 200;
      settings.formSchema.allFields.productBuyIds.width = 200;
      settings.formSchema.allFields.ecId.width = 120;
      settings.formSchema.allFields.boId.width = 120;
      settings.formSchema.allFields.amountNotPaid.width = 120;
      settings.formSchema.allFields.amountInVat.width = 150;
      settings.formSchema.allFields.amountExVat.width = 150;
      settings.formSchema.allFields.amountSa.width = 120;
      settings.formSchema.allFields.amountActual.width = 120;
      settings.formSchema.allFields.amountPaid.width = 120;
      settings.formSchema.allFields.remark.width = 150;

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const onSelectChange = (newSelectedRowKeys: Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initApplyRowFieldConfigs(record, data.ecFieldConfigs);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    },
    rowSelection: {selectedRowKeys: selectedRowKeys, onChange: onSelectChange}
  };

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
        description={<span>注意：本次货补申领信息”中的申领金额分摊到本列表的每一行上做为核销金额</span>}
        extra={
          <>
            <Button
              type="primary"
              onClick={() => {
                if (!selectedRowKeys || selectedRowKeys.length === 0) {
                  message.error('请选择要删除的行').then();
                  return;
                }
                if (confirm('将要删除选中的行，确定要继续吗？')) {
                  const newDataSource = props.dataSource.filter(item => !selectedRowKeys.includes(item.uid));
                  props?.onChange?.(newDataSource);
                  setSelectedRowKeys([]);
                }
              }}
              style={{float: 'right', marginRight: 10}}
            >
              删除
            </Button>
          </>
        }
      >
        {isLoaded && <DetailGrid {...pageGridSettings} params={data}/>}
      </WdiPanel>
    </>
  );
}

export const replaceColumns = {
  'soldToCode': [
    {name: 'soldToCode', displayName: '客户编号'},
    {name: 'soldToName', displayName: '客户名称'},
  ],
  'shopId': [
    {name: 'shopCode', displayName: '门店编号'},
    {name: 'shopName', displayName: '门店名称'},
  ],
  'shipToCode': [
    {name: 'shipToCode', displayName: '收货地编号'},
    {name: 'shipToName', displayName: '收货地名称'},
  ],
  'productBuyIds': [
    {name: 'productBuyNames', displayName: '产品别'},
  ],
  'ecId': [
    {name: 'ecName', displayName: '费用项'},
  ],
  'ecId1': [
    {name: 'ecName1', displayName: '费用大类'},
  ],
  'ecId2': [
    {name: 'ecName2', displayName: '费用小类'},
  ],
  'revenueType': [
    {name: 'revenueTypeName', displayName: '核算类型'},
  ],
  'boId': [
    {name: 'boName', displayName: '四级使用部门'},
  ],
  'boId1': [
    {name: 'boName1', displayName: '一级使用部门'},
  ],
  'boId2': [
    {name: 'boName2', displayName: '二级使用部门'},
  ],
  'boId3': [
    {name: 'boName3', displayName: '三级使用部门'},
  ],
  'custSysCode': [
    {name: 'custSysCode', displayName: '客户系统编号'},
    {name: 'custSysName', displayName: '客户系统名称'},
  ],
  'productFgId': [
    {name: 'productFgCode', displayName: '指定货补产品别编号'},
    {name: 'productFgName', displayName: '指定货补产品别名称'},
  ],
  'paymentMethodId': [
    {name: 'paymentMethodName', displayName: '支付方式'},
  ],
  'uomCode': [
    {name: 'uomName', displayName: '单位'},
  ],
  'activitySubjectId': [
    {name: 'activitySubjectName', displayName: '活动主题'},
  ],
  'displayTypeIds': [
    {name: 'displayTypeNames', displayName: '陈列形式'},
  ],
};

export const GeneralPaymentDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {

  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false, type: ModalAppTypeEnums.None});
  const [doesAccess, setDoesAccess] = useState<{ modifyAmount: boolean }>({modifyAmount: false});

  const {data, dataSource, onChange} = props;

  useEffect(() => {
    Promise.all([
      GridApi.searchConfig({id: "FormSPDetailForApproval", allowModifyColumns: true}),
      Position.access({useCaseId: Enum.UseCase.SP, operateTypeIds: [Enum.OperateType.MODIFY_AMOUNT]}),
    ]).then(dataArray => {
      const responseResult = dataArray[0];
      const allowModifyAmountRes = dataArray[1];
      const allowModifyAmount = allowModifyAmountRes.code == ResponseStatus.SUCCESS && allowModifyAmountRes.data;
      setDoesAccess({modifyAmount: allowModifyAmount})

      const settings: any = Object.assign({}, responseResult.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
        filterMenuActions: (actions: any, record: any) => {
          const newActions: any[] = [];
          if (actions) {
            actions.forEach((item: any) => {
              if (record.amountInVat != 0) {
                if (item.name == 'Update') {
                  newActions.push(item);
                }
              }
            });
          }
          return newActions;
        },
      });

      const actions: any[] = [];
      if (settings.formSchema.actions) {
        settings.formSchema.actions.forEach((item: any) => {
          //只在 当前单据是审批中&本单支付方式(第一条明细的)<>货补(KA)&（有修改核销金额权限）& 核销金额(含税)<>0时才显示；点击后弹出图1.1
          if (wdiCore.String.EqIngoreCase(item.name, 'Update')
            && (allowModifyAmount)
            && (data.formSp?.statusId == Enum.FormStatus.AWAITING)
            && (dataSource[0]?.paymentMethodId != Enum.PaymentMethod.FREE_GOODS)
          ) {
            Utility.setActionCallback(settings.formSchema.actions, 'Update',
              (grid: any, action: any, record: any) => {
                setModalProps({
                  title: '修改核销明细',
                  visible: true,
                  type: ModalAppTypeEnums.Edit,
                  id: null,
                  data: {
                    formSp: data.formSp,
                    row: record,
                  },
                });
              },
            );
            actions.push(item);
          }
        });
      }
      settings.formSchema.actions = actions;

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.tpmDetailId.getDisplayFormater = (text: any, record: any, index: any) => {
        return (
          <a onClick={() => {
            window.open(getFormUrlMapping(record.saPageTypeId, record.saFormTypeId) + `?formId=${record.formSaId}&pageTypeId=${record.saPageTypeId}&formTypeId=${record.saFormTypeId}`);
          }}>{record.tpmDetailId}
          </a>
        )
      };
      settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr('amountNotPaid', 2);
      settings.formSchema.allFields.quantityPosActualKeyin.aggr = TableColumnRanderFormats.sumAggr('quantityPosActualKeyin', 2);
      settings.formSchema.allFields.revenuePosActualKeyin.aggr = TableColumnRanderFormats.sumAggr('revenuePosActualKeyin', 2);
      settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr('amountExVat', 2);
      settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2);
      settings.formSchema.allFields.amountSa.aggr = TableColumnRanderFormats.sumAggr('amountSa', 2);
      settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);
      settings.formSchema.allFields.amountPaid.aggr = TableColumnRanderFormats.sumAggr('amountPaid', 2);
      settings.formSchema.allFields.tax.aggr = TableColumnRanderFormats.sumAggr('tax', 2);
      if (data.formSp?.paymentMethodId != Enum.PaymentMethod.BILL_DEDUCT && settings && settings.viewObject) {
        settings.viewObject.viewColumns = settings.viewObject.viewColumns.filter((item: any) => item != 'shipToCode');
      }
      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.soldToCode.width = 100;
      settings.formSchema.allFields.shipToCode.width = 100;
      settings.formSchema.allFields.productBuyIds.width = 100;
      settings.formSchema.allFields.ecId.width = 100;
      settings.formSchema.allFields.boId.width = 120;
      settings.formSchema.allFields.amountNotPaid.width = 120;
      settings.formSchema.allFields.quantityPosActualKeyin.width = 185;
      settings.formSchema.allFields.revenuePosActualKeyin.width = 200;
      settings.formSchema.allFields.amountInVat.width = 150;
      settings.formSchema.allFields.amountExVat.width = 150;
      settings.formSchema.allFields.remark.width = 150;

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initApplyRowFieldConfigs(record, data?.ecFieldConfigs);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    },
  };

  const onClose = () => {
    setModalProps({visible: false, type: ModalAppTypeEnums.None});
  };
  const onImportSave = () => {
    onClose();
    props?.onClose?.();
    PageControl.approval({
      formTypeId: data.formSp?.formTypeId,
      pageTypeId: data.formSp?.pageTypeId,
      data: {formId: data.formSp?.formSpId},
    });
  };

  return (
    <>
      {modalProps.visible && modalProps.type == ModalAppTypeEnums.ViewSfa && (
        <ViewSfaResultApp
          {...modalProps}
          onSave={onClose}
          onClose={onClose}
        />
      )}
      {modalProps.visible && modalProps.type == ModalAppTypeEnums.Edit && (
        <GeneralSpDetailEditApp
          {...modalProps}
          onSave={(result) => {
            onChange?.(DataStore.edit(dataSource, result?.data));
            setModalProps({visible: false, data: null});
          }}
          onClose={onClose}
        />
      )}
      {modalProps.visible && modalProps.type == ModalAppTypeEnums.Import && (
        <ModifyPaymentAmountModalApp
          {...modalProps}
          onClose={onClose}
          onSave={onImportSave}
        />
      )}
      <WdiPanel
        title={< WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
        collapsed={true}
        extra={
          <>
            {(doesAccess.modifyAmount)
              && (data.formSp?.statusId == Enum.FormStatus.AWAITING)
              && (dataSource.findIndex(m => m.paymentMethodId != Enum.PaymentMethod.FREE_GOODS && m.amountInVat != 0) > -1)
              && (
                <Button type='primary' onClick={(e) => {
                  setModalProps({
                    visible: true,
                    type: ModalAppTypeEnums.Import,
                    title: '批量修改核销明细',
                    id: data.formSp.formSpId,
                  });
                }} style={{float: 'right', marginRight: 10}}>
                  批量修改明细
                </Button>
              )
            }
            {data.allowViewSfa &&
              <Button type='primary' onClick={(e) => {
                setModalProps({
                  title: '活动单查看SFA执行结果',
                  visible: true,
                  type: ModalAppTypeEnums.ViewSfa,
                  id: data.form.formId,
                  data: {
                    dataSource: dataSource,
                    formTypeId: Enum.FormType.ACTIVITY_PAYMENT,
                  },
                });
              }} style={{float: 'right', marginRight: 10}}>
                查看SFA采集详情
              </Button>
            }
            <Button type='primary' onClick={(e) => {
              getSchemaColumns('FormSPDetailForApproval', replaceColumns).then(columns => {
                const sheet = {
                  data: dataSource,
                  names: columns,
                  sheetName: 'FormSPDetail',
                  cells: {
                    toSfa: (fieldObject: any, row: any, value: any) => {
                      return wdiCore.Boolean.Display(value);
                    }
                  }
                };
                toExcel({
                  name: data?.form?.formNo + '_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
                  sheetProps: [sheet],
                });
              });
            }} style={{float: 'right'}}>
              导出
            </Button>
          </>
        }
      >
        {isLoaded && <DetailGrid params={data} {...pageGridSettings} />}
      </WdiPanel>
    </>
  );
};

export const FreeGoodsPaymentDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {

  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const {data, dataSource} = props;

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSPDetailApprovalForFreeGoods', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.amountNotPaid.aggr = TableColumnRanderFormats.sumAggr('amountNotPaid', 2);
      settings.formSchema.allFields.amountExVat.aggr = TableColumnRanderFormats.sumAggr('amountExVat', 2);
      settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2);
      settings.formSchema.allFields.amountSa.aggr = TableColumnRanderFormats.sumAggr('amountSa', 2);
      settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);
      settings.formSchema.allFields.amountPaid.aggr = TableColumnRanderFormats.sumAggr('amountPaid', 2);
      settings.formSchema.allFields.tax.aggr = TableColumnRanderFormats.sumAggr('tax', 2);

      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.soldToCode.width = 100;
      settings.formSchema.allFields.productBuyIds.width = 100;
      settings.formSchema.allFields.ecId.width = 90;
      settings.formSchema.allFields.boId.width = 120;
      settings.formSchema.allFields.amountNotPaid.width = 120;
      settings.formSchema.allFields.amountInVat.width = 150;
      settings.formSchema.allFields.amountExVat.width = 150;
      settings.formSchema.allFields.remark.width = 150;
      settings.formSchema.allFields.tpmDetailId.width = 150;


      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initApplyRowFieldConfigs(record, data?.ecFieldConfigs);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  return (
    <WdiPanel
      title={< WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
      collapsed={true}
      extra={
        <>
          {data.allowViewSfa && (
            <Button type='primary' onClick={(e) => {
              FormSp.Buttons.viewSfaCollectionDetails({
                items: [],
                key: "",
                formId: data.formSp.formSpId
              }).then(responseResult => {
                if (responseResult.code === ResponseStatus.SUCCESS) {
                  window.open(responseResult.data);
                } else {
                  message.error(responseResult.message).then();
                }
              })
              e.stopPropagation();
            }} style={{float: 'right', marginRight: 10}}>
              查看活动采集详情
            </Button>
          )}
          <Button type='primary' onClick={(e) => {
            getSchemaColumns('FormSPDetailApprovalForFreeGoods', replaceColumns).then(columns => {
              const sheet = {
                data: dataSource,
                names: columns,
                sheetName: 'FormSPDetail',
                cells: {
                  toSfa: (fieldObject: any, row: any, value: any) => {
                    return wdiCore.Boolean.Display(value);
                  },
                  quantity: (fieldObject: any, row: any, value: any) => {
                    return wdiCore.Number.ToNumber(value, 5);
                  },
                }
              };
              toExcel({
                name: data?.form?.formNo + '_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
                sheetProps: [sheet],
              });
            });
            e.stopPropagation();
          }} style={{float: 'right'}}>
            导出
          </Button>
        </>
      }
    >
      {isLoaded && <DetailGrid {...pageGridSettings} />}
    </WdiPanel>
  );
};
